import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      marginBottom: '1rem',
    },
    box: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1rem',
    },
    title: {
      width: '200px',
      height: '30px',
    },
  },
  locationSelector: {
    main: {
      padding: '1rem',
      marginBottom: '1rem',
    },
    origin: {
      marginBottom: '0.5rem',
    },
    box: {
      height: '40px',
    },
  },
  navigation: {
    main: {
      marginBottom: '1rem',
    },
    box: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0.5rem',
    },
    button: {
      width: '50px',
      height: '30px',
    },
  },
  content: {
    main: {
      marginBottom: '1rem',
    },
    box: {
      padding: '0.5rem',
    },
    text: {
      height: '280px',
    },
  },
  legend: {
    main: {
      padding: '0.5rem',
    },
    text: {
      height: '20px',
    },
  },
};

const SkeletonFareCalendarMobile = (props) => {
  const [className, style] = useStyles(props);
  const { header, locationSelector, navigation, content, legend } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonLowFareCalendarMobile"
    >
      <Row gutters>
        <Col style={header.main}>
          <Box className="fr-skeleton-box" style={header.box}>
            <Box className="fr-skeleton-element" style={header.title} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={locationSelector.main}>
            <Col xs="12" style={locationSelector.origin}>
              <Box className="fr-skeleton-element" style={locationSelector.box} />
            </Col>
            <Col xs="12" style={locationSelector.origin}>
              <Box className="fr-skeleton-element" style={locationSelector.box} />
            </Col>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col style={navigation.main}>
          <Box className="fr-skeleton-box" style={navigation.box}>
            <Box className="fr-skeleton-element" style={navigation.button} />
            <Box className="fr-skeleton-element" style={navigation.button} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col style={content.main}>
          <Box className="fr-skeleton-box" style={content.box}>
            <Box className="fr-skeleton-element" style={content.text} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col xs="7">
          <Box className="fr-skeleton-box" style={legend.main}>
            <Row gutters>
              <Col xs="6">
                <Box className="fr-skeleton-element" style={legend.text} />
              </Col>
              <Col xs="6">
                <Box className="fr-skeleton-element" style={legend.text} />
              </Col>
            </Row>
          </Box>
        </Col>
      </Row>
    </Box>
  );
};

SkeletonFareCalendarMobile.componentName = 'SkeletonFareCalendarMobile';

export default SkeletonFareCalendarMobile;
